import { useSelector } from 'react-redux';

import {
  getCanCreatePendingMerge,
  getCountFailedPullRequestMergeChecks,
  getPullRequestIsMergeable,
  getPullRequestMergeChecks,
  getPullRequestMergeChecksIsMergeable,
  getConflictStatus,
} from 'src/redux/pull-request/selectors';

import { ClassicMergeCheckData } from './types';

export const useClassicMergeData = (): ClassicMergeCheckData => {
  const isConflicted = useSelector(getConflictStatus);
  const classicMergeChecks = useSelector(getPullRequestMergeChecks);
  const classicPullRequestIsMergeable = useSelector(getPullRequestIsMergeable);

  const classicPullRequestMergeChecksIsMergeable = useSelector(
    getPullRequestMergeChecksIsMergeable
  );
  const classicCanCreatePendingMerge = useSelector(getCanCreatePendingMerge);
  const classicChecksFailedCount = useSelector(
    getCountFailedPullRequestMergeChecks
  );

  return {
    classicPullRequestIsMergeable:
      classicPullRequestIsMergeable && !isConflicted,
    classicPullRequestMergeChecksIsMergeable:
      classicPullRequestMergeChecksIsMergeable && !isConflicted,
    classicCanCreatePendingMerge: classicCanCreatePendingMerge && !isConflicted,
    classicChecksFailedCount,
    classicChecksTotalCount: classicMergeChecks.length,
  };
};
